import { graphql, useStaticQuery } from 'gatsby'

interface ShopifyVariant {
  sku: string
  storefrontId: string
}

interface CartBundleLineItem {
  variantId: string
  quantity: number
}

const skuBundleMap: Record<string, string[]> = {
  'pentukurssi-pentupakettiin': ['pentukurssi-verkossa'],
}

export const useCartBundle = () => {
  const data = useStaticQuery(graphql`
    query CartBundleVariantsQuery {
      allShopifyProductVariant {
        nodes {
          sku
          storefrontId
        }
      }
    }
  `)

  const allVariants: ShopifyVariant[] = data.allShopifyProductVariant.nodes

  const getBundledLineItems = (sku: string): CartBundleLineItem[] => {
    const bundledSkus = skuBundleMap[sku] || []

    return bundledSkus
      .map((bundledSku) => {
        const matchingVariant = allVariants.find(
          (variant) => variant.sku === bundledSku
        )
        if (!matchingVariant) {
          return null
        }
        return {
          variantId: matchingVariant.storefrontId,
          quantity: 1,
        }
      })
      .filter((lineItem): lineItem is CartBundleLineItem => lineItem !== null)
  }

  return { getBundledLineItems }
}
